import React, { CSSProperties, FC, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDropzone } from "react-dropzone";

import Delete from "~/components/Icons/Delete";
import s from "./DropZone.less";
import clsx from "clsx";

const baseStyle = {
  position: "relative",
  borderRadius: "20px",
  font: "bold 24px arial",
  textAlign: "center",
  padding: "2px",
  height: "100%",
  lineHeight: "56px",
  border: "2px dotted lightgray",
  overflow: "hidden",
  color: "lightgray",
  fontSize: "23px",
  outline: "none",
  cursor: "pointer",
  transition: "border .24s ease-in-out",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

const activeStyle = {
  border: "2px solid #4a4a4a",
  color: "#4a4a4a",
};

const acceptStyle = {
  border: "2px solid #4a4a4a",
  color: "#4a4a4a",
};

const rejectStyle = {
  border: "2px solid #4a4a4a",
  color: "#4a4a4a",
};

interface IProps {
  getFiles?: (i: File[]) => void;
  setFile?;
  fileActive?;
  accept?: string;
  isOne?: boolean;
  clear?: boolean;
  showFormats?: boolean;
  customPlaceholder?: string;
  customStyles?;
  customWrapper?;
  customTitleClass?;
  customContainerClass?;
}

const DropZone: FC<IProps> = ({
  getFiles,
  setFile,
  fileActive,
  accept = "*/*",
  isOne = false,
  clear = false,
  showFormats = false,
  customPlaceholder,
  customStyles,
  customWrapper,
  customTitleClass,
  customContainerClass,
}) => {
  const { t } = useTranslation();
  const [files, setFiles] = useState(fileActive || []);
  const [isManyFiles, setIsManyFiles] = useState(false);
  useEffect(() => {
    console.log("файл загружен", files);
  }, [files]);
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept,
    onDrop: (acceptedFiles) => {
      getFiles && getFiles(acceptedFiles);
      setFiles(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
    },
  });

  const style: CSSProperties | any = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
      ...(customStyles ? customStyles : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  useEffect(() => {
    if (isOne && files.length > 1) {
      setIsManyFiles(true);
      setFiles([files[0]]);
    }
  }, [files]);

  useEffect(() => {
    clear && setFiles([]);
  }, [clear]);

  return (
    <div
      className={clsx(s.container, {
        [customContainerClass]: !!customContainerClass,
      })}
    >
      {files.length > 0 ? (
        <div>
          {files.map((file) => {
            return accept === ("image/*" || "image") ? (
              <div key={file.name}>
                <div>
                  <img
                    src={file.preview}
                    style={{ width: "20px" }}
                    alt={"preview"}
                  />
                  {file.name}
                </div>
                <div
                  className={s.delete_file}
                  onClick={() => {
                    setFiles(files.filter((f) => f.name !== file.name));
                    setIsManyFiles(false);
                  }}
                >
                  <Delete />
                </div>
              </div>
            ) : (
              <div
                className={clsx({
                  [customWrapper]: !!customWrapper,
                })}
                key={file.name}
              >
                <div className={s.not_image}>{file.name}</div>
                <div
                  className={s.delete_file}
                  onClick={() => {
                    setFiles(files.filter((f) => f.name !== file.name));
                    setIsManyFiles(false);
                    setFile({});
                  }}
                >
                  <Delete />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div {...getRootProps({ style })}>
          <input {...getInputProps()} />
          <div
            className={clsx(s.title, {
              [customTitleClass]: !!customTitleClass,
            })}
          >
            {customPlaceholder || t("ui.drop_file")}{" "}
            {showFormats && (accept === "*/*" ? "" : accept)}
          </div>
        </div>
      )}
      {isManyFiles && (
        <div className={s.only_one_file}>{t("errors.only_one_file")}</div>
      )}
    </div>
  );
};
export default DropZone;
